import React from 'react'
import { useSelector } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'
import ToggleField from 'components/Shared/Forms/ToggleField'

export default function ExternalLinkOptions({ field, action, formName }) {
  const fieldName = `${field}.options.useSystemBrowser`
  const selector = formName ? formValueSelector(formName) : null
  const useSystemBrowser =
    useSelector(state => (selector ? selector(state, fieldName) : null)) ??
    action.options?.useSystemBrowser

  return (
    <div className="external-link-options">
      <Field
        boxed
        inverted
        component={ToggleField}
        name={fieldName}
        color="yellow"
        label="Use In-app Browser"
        inputValue={useSystemBrowser ? 'Off' : 'On'}
      />
    </div>
  )
}
